import { AxiosError } from 'axios';
import { AxiosErrorData } from '../../../types/axios-errors';

const isNetworkError = (error: Error) => error?.stack?.startsWith('Error: Network Error');

export const formatAxiosError = (error: AxiosError<AxiosErrorData>) => {
  let formattedMessage = '';

  if (isNetworkError(error)) {
    formattedMessage = 'A network error has occurred. Please check your internet connection.';
  } else {
    const apiMessage = error.response?.data?.error?.message;
    if (apiMessage) {
      formattedMessage = `${apiMessage}`;
    }
  }

  error.message = formattedMessage; // eslint-disable-line no-param-reassign
  return error;
};

export default formatAxiosError;
